import { EditorState } from "prosemirror-state";
export default function getEditorStateClass() {
  return EditorState;
}